<div class="row">
  <div class="col-md-12 grid-margin">
    <div class="card p-2">
      <div class="card-body">
        <h5 class="mb-3">Wallet Registration</h5>

        <div *ngIf="phase === 'unavailable'" class="text-muted">
          This step is only available right after onboarding a new merchant. Please onboard the merchant first.
        </div>

        <ng-container *ngIf="data && phase !== 'unavailable'">
          <div class="row mb-3">
            <div class="col-sm-6 mb-2"><strong>Mobile Number:</strong> {{ data.mobileNumber }}</div>
            <div class="col-sm-6 mb-2"><strong>Name:</strong> {{ data.firstName }} {{ data.lastName }}</div>
            <div class="col-sm-6 mb-2"><strong>National ID:</strong> {{ data.nationalId }}</div>
            <div class="col-sm-6 mb-2"><strong>ID Expiry Date:</strong> {{ data.expirationDate }}</div>
          </div>

          <div *ngIf="phase === 'confirm'" class="text-end">
            <button class="btn bg-danger-custom" type="button" [disabled]="sending" (click)="register()">
              {{ sending ? 'Sending...' : 'Register' }}
            </button>
          </div>

          <form *ngIf="phase === 'otp'" (ngSubmit)="verify()">
            <div class="row">
              <div class="col-sm-6">
                <app-text-input
                  label="OTP" [required]="true" [control]="otp.otp"
                  [submitted]="isOtpSubmitted" [serverError]="otpError" id="otp"
                  placeholder="Enter the OTP sent to the client" autocomplete="off" [maxlength]="10"
                ></app-text-input>
              </div>
            </div>
            <div class="text-end mt-2">
              <button class="btn btn-secondary me-2" type="button" [disabled]="sending" (click)="register()">
                Resend OTP
              </button>
              <button class="btn bg-danger-custom" type="submit" [disabled]="verifying">
                {{ verifying ? 'Verifying...' : 'Verify' }}
              </button>
            </div>
          </form>

          <div *ngIf="phase === 'done'" class="text-center">
            <i class="feather icon-check-circle text-success" style="font-size: 48px;"></i>
            <h5 class="mt-3">Wallet registered successfully</h5>
            <button class="btn bg-danger-custom mt-2" type="button" (click)="goToMerchantList()">
              Back to Merchant Master
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
